/**
 * Where verified users land after OTP success.
 *
 * An invite link wins first — accepting it establishes the org membership that a pending MCP OAuth consent may REQUIRE
 * (JoinPage then resumes the consent). If there is no invite, a pending OAuth consent context resumes next. Otherwise use
 * `nextSetupPath` when safe; `/setup` only resolves when chat-first onboarding is enabled in the build.
 */

export function resolvePostVerificationDestination({
  pendingInviteToken,
  pendingOAuthContext,
  chatFirstSetupEnabled,
  nextSetupPath,
}) {
  const pendingTrimmed = pendingInviteToken != null ? String(pendingInviteToken).trim() : ''

  if (pendingTrimmed.length > 0) {
    // Keep the OAuth context stashed (clearOAuthContext: false) — JoinPage resumes it after the invite is accepted.
    return {
      path: `/join?token=${encodeURIComponent(pendingTrimmed)}`,
      clearInviteToken: true,
      clearOAuthContext: false,
    }
  }

  const oauthTrimmed = pendingOAuthContext != null ? String(pendingOAuthContext).trim() : ''
  if (oauthTrimmed.length > 0) {
    return {
      path: `/mcp-authorize?${oauthTrimmed}`,
      clearInviteToken: false,
      clearOAuthContext: true,
    }
  }

  const defaultSetup = '/setup'
  let candidate =
    typeof nextSetupPath === 'string' && nextSetupPath.trim().length > 0 ? nextSetupPath.trim() : defaultSetup

  if (candidate === '/setup' && !chatFirstSetupEnabled) {
    return { path: '/dashboard', clearInviteToken: false }
  }

  return { path: candidate, clearInviteToken: false }
}
